<template>
  <div class="row align-self-center ">
      <div id="language" class="btn-group btn-group-sm" role="group" aria-label="Language">
          <a v-if="manualOne" type="button" class="btn btn_language" :href="authServiceBaseUrl + manualOne" target="_blank">{{ $i18n.locale === 'bn' ? 'ম্যানুয়াল' : 'Manual' }}</a>
          <a v-if="manualTwo" type="button" class="btn btn_language" :href="authServiceBaseUrl + manualTwo" target="_blank">{{ $i18n.locale === 'bn' ? 'ম্যানুয়াল' : 'Manual' }}{{ $n(2) }}</a>
          <button type="button" class="btn btn_language" @click="changeLang()">{{ langLabel }}</button>
      </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import RestApi, { authServiceBaseUrl } from '@/config/api_config'

export default {
  data () {
    return {
      authServiceBaseUrl: authServiceBaseUrl,
      manualOne: '',
      manualTwo: ''
    }
  },
  created () {
    this.callAllManual()
  },
  computed: {
    langLabel: function () {
      return this.$i18n.locale === 'en' ? 'বাংলা' : 'English'
    }
  },
  methods: {
      async callAllManual () {
        const activeRoleId = this.$store.state.Auth.activeRoleId
        const authUserRoles = this.$store.state.Auth.authUserRoles
        const authUser = this.$store.state.Auth.authUser
        const roleId = authUserRoles && authUserRoles.length > 0 ? authUserRoles[0].id : (activeRoleId > 0 ? activeRoleId : '')
        const orgId = authUserRoles && authUserRoles.length > 0 ? authUserRoles[0].org_id : (authUser ? authUser.org_id : '')
        if (!roleId || !orgId) {
            this.manualOne = null
            this.manualTwo = null
        }
        try {
            const response = await RestApi.getData(authServiceBaseUrl, '/manual-upload/manual-all')
            if (response && response.success) {
                const manualData = response?.data.filter(
                    (item) =>
                        item.org_id === parseInt(orgId) && item.role_id === parseInt(roleId)
                )
                if (manualData && manualData.length > 0) {
                    this.manualOne = manualData[0].pdf_file
                    this.manualTwo = manualData[0].pdf_file_two
                } else {
                    this.manualOne = null
                    this.manualTwo = null
                }
            } else {
                this.manualOne = null
                this.manualTwo = null
            }
        } catch (error) {
            this.manualOne = null
            this.manualTwo = null
        }
    },
    changeLang () {
      this.$i18n.locale = this.$i18n.locale === 'bn' ? 'en' : 'bn'
      this.setLocale(this.$i18n.locale)
    },
    ...mapActions({
      setLocale: 'Setting/setLangAction'
    })
  }
}
</script>
